module.exports = __webpack_public_path__ + "static/media/DragArrows.26288746.png";